/** True when copy is HTML (rich product description). */
export function isRichHtml(text: string): boolean {
  return /^\s*</.test(text);
}

/** Plain text for meta description and JSON-LD from HTML copy. */
export function stripHtmlForMeta(html: string): string {
  return html
    .replace(/<[^>]+>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

/** Remove leading h1 (page title is rendered by the product layout). */
export function prepareRichAboutHtml(html: string): { pageTitle: string | null; bodyHtml: string } {
  const h1Match = html.match(/<h1[^>]*>([\s\S]*?)<\/h1>/i);
  const pageTitle = h1Match ? stripHtmlForMeta(h1Match[1]) : null;

  const body = html.replace(/<h1[^>]*>[\s\S]*?<\/h1>\s*/i, "");

  return { pageTitle, bodyHtml: body.trim() };
}

/** Parse finished model dimensions from blockSize when stored as W × H × L. */
export function parseModelDimensions(
  blockSize: string | undefined
): { width?: string; height?: string; length?: string } {
  if (!blockSize || blockSize === "normal") return {};
  const match = blockSize.match(
    /([\d.,]+\s*cm)\s*[×x]\s*([\d.,]+\s*cm)\s*[×x]\s*([\d.,]+\s*cm)/i
  );
  if (!match) return {};
  return { width: match[1], height: match[2], length: match[3] };
}

/** Canonical product page H1, e.g. 12GO Type 99B Main Battle Tank 1:28 - 97032 */
export function buildProductPageTitle(product: {
  name?: string;
  numbering: string;
  scale?: string;
  brand?: string;
}): string {
  const brand = product.brand || "12GO";
  const name = product.name ?? `${brand} ${product.numbering}`;
  const scalePart = product.scale?.trim() ? ` ${product.scale.trim()}` : "";
  return `${brand} ${name}${scalePart} - ${product.numbering}`;
}
